import useUser from "../../../hooks/useUser";
import useBreakpoint from "../../../hooks/useBreakpoint";
import { useEffect, useState} from "react";
import { useLazyQuery } from "@apollo/client";

import Accordion from 'react-bootstrap/Accordion';
import { Button, Col, Form, Row, Table } from 'react-bootstrap';
import { faDownload, faCircleInfo, faInfo, faFileZipper } from "@fortawesome/free-solid-svg-icons";
import COLORS from "../../../data/colors";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useTranslation } from 'react-i18next';

import GET_FACTSHEET from "../../../graphql/queries/IIAs/getFactsheet";
import GET_FACTSHEET_BY_ERASMUS_CODE from "../../../graphql/queries/IIAs/getFactsheetByErasmusCode";
import GET_FACTSHEET_PDF from "../../../graphql/queries/IIAs/getFactsheetPdf";
import GET_FACTSHEET_PDF_BY_ERASMUS_CODE from "../../../graphql/queries/IIAs/getFactsheetPdfByErasmusCode";

import CustomModal from "..";
import CustomButton from "../../CustomButton";

import "./index.scss";

const PartnerFactSheetModal = ({ 
    heiId,
    erasmusCode,
    styles,
    disabled,
    small = false
}) => {

    const { t } = useTranslation('translation', { keyPrefix: 'iiaSingleView' })
    const [ size ] = useBreakpoint();
    
    
    const [ hasData, setHasData ] = useState(false);
    const [ hasBase64, setHasBase64 ] = useState(false);
    
    const [ showParentFactsheet, setShowParentFactsheet ] = useState(false);
    const [ pdfURL, setPdfURL ] = useState("");

    const handleCloseParentFactsheet = () => setShowParentFactsheet(false);
    const handleShowParentFactsheet = () => setShowParentFactsheet(true);

    function handleParentFactsheet(e) {
        e.stopPropagation();
        showParentFactsheet ? handleCloseParentFactsheet() : handleShowParentFactsheet();
    }

    const [ fetchFactsheetPdf, {data, loading, error, refetch: refetchFactsheetPdf} ] = 
    useLazyQuery(GET_FACTSHEET_PDF, 
        { notifyOnNetworkStatusChange: true, fetchPolicy: 'network-only', variables: { heiID: heiId },
        onCompleted: (data) => {
            
            data?.factsheetPdf ? setHasBase64(true) : setHasBase64(false);

            let base64Str = data?.factsheetPdf;

            if (base64Str) {
                let byteCharacters = atob(base64Str);
                let byteNumbers = new Array(byteCharacters.length);

                for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                let byteArray = new Uint8Array(byteNumbers);
                let file = new Blob([byteArray], { type: "application/pdf;base64" });
                const fileURL = URL.createObjectURL(file);
                setPdfURL(fileURL);
            }    
        }
    });

    const [ fetchFactsheetPdfEcode, {dataEcode, loadingEcode, errorEcode, refetch: refetchFactsheetPdfEcode} ] = 
    useLazyQuery(GET_FACTSHEET_PDF_BY_ERASMUS_CODE, 
        { notifyOnNetworkStatusChange: true, fetchPolicy: 'network-only', variables: { erasmusCode: erasmusCode },
        onCompleted: (data) => {

            data?.factsheetPdfByErasmusCode ? setHasBase64(true) : setHasBase64(false);

            let base64Str = data?.factsheetPdfByErasmusCode;
            
            if (base64Str) {
                let byteCharacters = atob(base64Str);
                let byteNumbers = new Array(byteCharacters.length);

                for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                let byteArray = new Uint8Array(byteNumbers);
                let file = new Blob([byteArray], { type: "application/pdf;base64" });
                const fileURL = URL.createObjectURL(file);
                setPdfURL(fileURL);
            }
        }
    });
    
    const [calendarNomAutumnPartner, setCalendarNomAutumnPartner] = useState("");
    const [calendarNomSpringPartner, setCalendarNomSpringPartner] = useState("");
    const [calendarAppSpringPartner, setCalendarAppSpringPartner] = useState("");
    const [calendarAppAutumnPartner, setCalendarAppAutumnPartner] = useState("");
    const [applicationInfoEmailPartner, setApplicationInfoEmailPartner] = useState("");
    const [applicationInfoPhonePartner, setApplicationInfoPhonePartner] = useState("");
    const [applicationInfoWebsitePartner, setApplicationInfoWebsitePartner] = useState([]);
    const [additionalRequirementsPartner, setAdditionalRequirementsPartner] = useState([]);
    const [additionalInfosPartner, setAdditionalInfosPartner] = useState([]);
    const [accessibilitiesPartner, setAccessibilitiesPartner] = useState([]);
    const [housingInfoPartner, setHousingInfoPartner] = useState({});
    const [visaInfoPartner, setVisaInfoPartner] = useState({});
    const [insuranceInfoPartner, setInsuranceInfoPartner] = useState({});

    const [ fetchHeiFactsheetPartner, { loading: loadingHeiFactsheetPartner, errorHeiFactsheetPartner, dataHeiFactsheetPartner, refetch: refetchHeiFactsheetPartner, called: calledHeiFactsheetPartner, }] =
        useLazyQuery(
            GET_FACTSHEET, { notifyOnNetworkStatusChange: true, fetchPolicy: 'network-only', variables: {
                heiID: heiId
              },
                onCompleted: (data) =>  {
                    data?.factsheet ? setHasData(true) : setHasData(false);
                    setCalendarNomAutumnPartner(data?.factsheet?.calendar?.student_nom_autumn_term);
                    setCalendarNomSpringPartner(data.factsheet?.calendar?.student_nom_spring_term);
                    setCalendarAppAutumnPartner(data?.factsheet?.calendar?.student_app_autumn_term);
                    setCalendarAppSpringPartner(data.factsheet?.calendar?.student_app_spring_term);
                    setAdditionalRequirementsPartner(data.factsheet?.additional_requirements);
                    setAccessibilitiesPartner(data?.factsheet?.accessibilities);
                    setHousingInfoPartner(data?.factsheet?.housing_info);
                    setVisaInfoPartner(data?.factsheet?.visa_info);
                    setInsuranceInfoPartner(data?.factsheet?.insurance_info);
                    setApplicationInfoEmailPartner(data?.factsheet?.application_info?.email);
                    setApplicationInfoPhonePartner(data.factsheet?.application_info?.phone_number?.e164);
                    setApplicationInfoWebsitePartner(data?.factsheet?.application_info?.website_urls);
                    setAdditionalInfosPartner(data?.factsheet?.additional_infos);
                
                }
            }
        );

    const [ fetchErasmusCodeFactsheetPartner, { loading: loadingErasmusCodeFactsheetPartner, errorErasmusCodeFactsheetPartner, dataErasmusCodeFactsheetPartner, refetch: refetchErasmusCodeFactsheetPartner, called: calledErasmusCodeFactsheetPartner, }] =
    useLazyQuery(
        GET_FACTSHEET_BY_ERASMUS_CODE, { notifyOnNetworkStatusChange: true, fetchPolicy: 'network-only', variables: {
            erasmusCode: erasmusCode
          },
            onCompleted: (data) =>  {
                data?.factsheetByErasmusCode ? setHasData(true) : setHasData(false);
                setCalendarNomAutumnPartner(data?.factsheetByErasmusCode?.calendar?.student_nom_autumn_term);
                setCalendarNomSpringPartner(data.factsheetByErasmusCode?.calendar?.student_nom_spring_term);
                setCalendarAppAutumnPartner(data?.factsheetByErasmusCode?.calendar?.student_app_autumn_term);
                setCalendarAppSpringPartner(data.factsheetByErasmusCode?.calendar?.student_app_spring_term);
                setAdditionalRequirementsPartner(data.factsheetByErasmusCode?.additional_requirements);
                setAccessibilitiesPartner(data?.factsheetByErasmusCode?.accessibilities);
                setHousingInfoPartner(data?.factsheetByErasmusCode?.housing_info);
                setVisaInfoPartner(data?.factsheetByErasmusCode?.visa_info);
                setInsuranceInfoPartner(data?.factsheetByErasmusCode?.insurance_info);
                setApplicationInfoEmailPartner(data?.factsheetByErasmusCode?.application_info?.email);
                setApplicationInfoPhonePartner(data.factsheetByErasmusCode?.application_info?.phone_number?.e164);
                setApplicationInfoWebsitePartner(data?.factsheetByErasmusCode?.application_info?.website_urls);
                setAdditionalInfosPartner(data?.factsheetByErasmusCode?.additional_infos);
            
            }
        }
    );
    
    useEffect(() => {
        setHasData(false);
        setHasBase64(false);
        setPdfURL("");
        if (heiId) {
            refetchHeiFactsheetPartner(heiId);
            refetchFactsheetPdf(heiId);
        }
        else if (erasmusCode) {
            refetchErasmusCodeFactsheetPartner(erasmusCode);
            refetchFactsheetPdfEcode(erasmusCode);
        }
    }, [heiId, erasmusCode]);

    return (
    <>
    <Button
        className={`${!(loadingEcode || loading) && hasData && !disabled ? "factsheet-primary-blue" : "factsheet-primary-blue-disabled"}`}
        type={"button"}
        id={small ? "small-factsheet" : "medium-factsheet"}
        disabled={!(loadingEcode || loading) && hasData && !disabled ? false : true}
        onClick={(e) => {handleParentFactsheet(e);}}
        style={{...styles}}
    >
        <span>
          <FontAwesomeIcon
            className="with-icon"
            id="smallIcon"
            icon={faCircleInfo}
          />
        </span>
        {t('partnerData.viewFactsheet')}
    </Button>
    
    <div onClick={e => e.stopPropagation()}>

    <CustomModal show={showParentFactsheet}
    handleClose={handleCloseParentFactsheet}
    size={"xl"}
    title={<div>{t('partnerData.title')}</div>} 
    button={
        (
        <a class={!hasBase64 ? "disableLink" : ""} href={pdfURL} target="_blank">
            <CustomButton
            buttonType={"secondary"} 
            small={true} 
            text={t('partnerData.exportFactsheet')} 
            hasIcon={true} 
            icon={faFileZipper} 
            iconColor={COLORS.pink}
            disabled={hasBase64 ? false : true}
            />
        </a>
        )
    }
    body={
    <>
    {(size !== "md" && size !== "sm" && size !== "xs") ? (
    <Row style={{marginLeft: 25, marginRight: 25}}>
                    <Col style={{marginTop: 30, marginBottom: 12}} md={12} lg={12}>
                        
                        <Accordion className='border-hidden label-style' style={{marginBottom: 12}} id={"accordion-iias-active"}>
                            <Accordion.Item eventKey="0" className='label-style'>
                                <Accordion.Header className='document-item label-style'>{t('partnerData.calendar.title')}</Accordion.Header>
                                <Accordion.Body className='border-hidden label-style' >
                                    <div style={{paddingLeft: 12, paddingTop: 15, paddingBottom: 20}}>
                                    <div className='h6-style'>{t('partnerData.calendar.studentNominations')}</div>
                                    <Row style={{marginTop: 12}}>
                                        <Col lg={2}>{t('partnerData.calendar.autumnTerm')}</Col>
                                        <Col lg={11} className='body'>{calendarNomAutumnPartner}</Col>
                                    </Row>
                                    
                                    <Row style={{marginTop: 12}}>
                                        <Col lg={2}>{t('partnerData.calendar.springTerm')}</Col>
                                        <Col lg={11} className='body'>{calendarNomSpringPartner}</Col>
                                    </Row>
                                    <div className='h6-style' style={{marginTop: 22}}>{t('partnerData.calendar.applicationsForNominated')}</div>
                                    <Row style={{marginTop: 12}}>
                                        <Col lg={2}>{t('partnerData.calendar.autumnTerm')}</Col>
                                        <Col lg={11} className='body'>{calendarAppAutumnPartner}</Col>
                                    </Row>
                                    
                                    <Row style={{marginTop: 12}}>
                                        <Col lg={2}>{t('partnerData.calendar.springTerm')}</Col>
                                        <Col lg={11} className='body'>{calendarAppSpringPartner}</Col>
                                    </Row>
                                    <div className='h6-style' style={{marginTop: 22}}>{t('partnerData.calendar.applicationProcedure')}</div>
                                    <Row style={{marginTop: 12}}>
                                        <Col lg={2}>{t('partnerData.calendar.email')}</Col>
                                        <Col lg={10} className='body'>{applicationInfoEmailPartner}</Col>
                                    </Row>
                                    
                                    <Row style={{marginTop: 12}}>
                                        <Col lg={2}>{t('partnerData.calendar.phone')}</Col>
                                        <Col lg={10} className='body'>{applicationInfoPhonePartner}</Col>
                                    </Row>
                                    <Row style={{marginTop: 12}}>
                                        <Col lg={2}>{t('partnerData.calendar.websiteForInfo')}</Col>
                                        <Col lg={10} className='body'>{applicationInfoWebsitePartner?.length > 0 && applicationInfoWebsitePartner}</Col>
                                    </Row>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    
                        
                        <Accordion className='border-hidden label-style' style={{marginBottom: 12}} id={"accordion-iias-active"}>
                            <Accordion.Item eventKey="0" className='label-style'>
                                <Accordion.Header className='document-item label-style'>{t('partnerData.additionalRequirements.title')}</Accordion.Header>
                                <Accordion.Body className='border-hidden label-style'>
                                    <Table border={1} frame="void" rules="rows">
                                        <thead className='thead-font'>
                                            <tr>
                                            <th style={{paddingTop: 15, paddingBottom: 2, paddingLeft: 12}} className='border-hidden label-style'>{t('partnerData.additionalRequirements.requirements')}</th>
                                            <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{t('partnerData.additionalRequirements.details')}</th>
                                            <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{t('partnerData.additionalRequirements.ectsNumber')}</th>
                                            <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{t('partnerData.additionalRequirements.subjectFieldISCED')}</th>
                                            <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{t('partnerData.additionalRequirements.studyLevelEQF')}</th>
                                            <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{t('partnerData.additionalRequirements.website')}</th>
                                            </tr>
                                        </thead>
                                        <tbody className='tbody-font'>
                                            {additionalRequirementsPartner?.map((elem, index) => (
                                                <tr>
                                                <td style={{paddingBottom: 20, paddingLeft: 12}} className='border-hidden body'>{elem?.name}</td>
                                                <td style={{paddingBottom: 20}} className='border-hidden body'>{elem?.details}</td>
                                                <td style={{paddingBottom: 20}} className='border-hidden body'>{elem?.ects}</td>
                                                <td style={{paddingBottom: 20}} className='border-hidden body'>{elem?.isced_f_code + elem?.isced_f_code_name}</td>
                                                <td style={{paddingBottom: 20}} className='border-hidden body'>{elem?.eqf_level}</td>
                                                <td style={{paddingBottom: 20}} className='border-hidden body'><a href={elem?.information_websites} target="_blank" style={{textDecoration: "none"}}>{elem?.information_websites}</a></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                    <div className='body' style={{marginTop: 15, fontStyle: "italic", paddingLeft: 12}}>{t('partnerData.additionalRequirements.message')}</div>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
    
                        <Accordion className='border-hidden label-style' style={{marginBottom: 12}} id={"accordion-iias-active"}>
                            <Accordion.Item eventKey="0" className='label-style'>
                                <Accordion.Header className='document-item label-style'>{t('partnerData.inclusionAndAccessibility.title')}</Accordion.Header>
                                <Accordion.Body className='border-hidden label-style'>
                                    <div className='body' style={{marginTop: 15, fontStyle: "italic", paddingLeft: 12}}>{t('partnerData.inclusionAndAccessibility.descriptionMain.part1')}<br/>{t('partnerData.inclusionAndAccessibility.descriptionMain.part2')}</div>
                                    <div className='h6-style' style={{marginTop: 22, paddingLeft: 12}}>{t('partnerData.inclusionAndAccessibility.infrastructure')} </div>
                                    <Table responsive>
                                        <thead className='thead-font'>
                                            <tr>
                                            <th style={{paddingTop: 15, paddingBottom: 2, paddingLeft: 12}} className='border-hidden label-style'>{t('partnerData.inclusionAndAccessibility.name')}</th>
                                            <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{t('partnerData.inclusionAndAccessibility.description')}</th>
                                            <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{t('partnerData.inclusionAndAccessibility.contact')}</th>
                                            </tr>
                                        </thead>
                                        <tbody className='tbody-font'>
                                            {accessibilitiesPartner?.map((elem, index) => (
                                                elem?.type?.startsWith("infrastructure") && <tr>
                                                <td style={{paddingBottom: 20, paddingLeft: 12}} className='border-hidden body'>{elem?.name}</td>
                                                <td style={{paddingBottom: 20}} className='border-hidden body'>{elem?.description}</td>
                                                <td style={{paddingBottom: 20}} className='border-hidden body'>{elem?.info?.email}{elem?.info?.phone_number?.e164 ? ", " 
                                                + elem?.info?.phone_number?.e164 : ""}{elem?.info?.website_urls ? ", " 
                                                + elem?.info?.website_urls : ""}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                    <div className='h6-style' style={{marginTop: 22, paddingLeft: 12}}>{t('partnerData.inclusionAndAccessibility.services')}</div>
                                    <Table responsive>
                                        <thead className='thead-font'>
                                            <tr>
                                            <th style={{paddingTop: 15, paddingBottom: 2, paddingLeft: 12}} className='border-hidden label-style'>{t('partnerData.inclusionAndAccessibility.name')}</th>
                                            <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{t('partnerData.inclusionAndAccessibility.description')}</th>
                                            <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{t('partnerData.inclusionAndAccessibility.contact')}</th>
                                            </tr>
                                        </thead>
                                        <tbody className='tbody-font'>
                                            {accessibilitiesPartner?.map((elem, index) => (
                                                elem?.type?.startsWith("service") && <tr>
                                                <td style={{paddingBottom: 20, paddingLeft: 12}} className='border-hidden body'>{elem?.name}</td>
                                                <td style={{paddingBottom: 20}} className='border-hidden body'>{elem?.description}</td>
                                                <td style={{paddingBottom: 20}} className='border-hidden body'>{elem?.info?.email}{elem?.info?.phone_number?.e164 ? ", " 
                                                + elem?.info?.phone_number?.e164 : ""}{elem?.info?.website_urls ? ", " 
                                                + elem?.info?.website_urls : ""}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
    
                        <Accordion className='border-hidden label-style' style={{marginBottom: 12}} id={"accordion-iias-active"}>
                            <Accordion.Item eventKey="0" className='label-style'>
                                <Accordion.Header className='document-item label-style'>{t('partnerData.housing.title')}</Accordion.Header>
                                <Accordion.Body className='border-hidden label-style'>
                                    <div className='body' style={{marginTop: 8, fontStyle: "italic", paddingLeft: 12}}>{t('partnerData.housing.description.part1')}<br/>{t('partnerData.housing.description.part2')}</div>
                                    <div className='h6-style' style={{marginTop: 10, paddingLeft: 12}}>{t('partnerData.housing.contact')} </div>
                                    <div className='body' style={{marginTop: 8, paddingLeft: 12}}>{housingInfoPartner?.email}{housingInfoPartner?.phone_number?.e164 ? ", " + housingInfoPartner?.phone_number?.e164 : ""}{housingInfoPartner?.website_urls ? ", " + housingInfoPartner?.website_urls : ""}</div>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
    
                        <Accordion className='border-hidden label-style' style={{marginBottom: 12}} id={"accordion-iias-active"}>
                            <Accordion.Item eventKey="0" className='label-style'>
                                <Accordion.Header className='document-item label-style'>{t('partnerData.visa.title')}</Accordion.Header>
                                <Accordion.Body className='border-hidden label-style'>
                                    <div className='body' style={{marginTop: 8, fontStyle: "italic", paddingLeft: 12}}>{t('partnerData.visa.description.part1')}<br/>{t('partnerData.visa.description.part2')}</div>
                                    <div className='h6-style' style={{marginTop: 10, paddingLeft: 12}}>{t('partnerData.visa.contact')} </div>
                                    <div className='body' style={{marginTop: 8, paddingLeft: 12}}>{visaInfoPartner?.email}{visaInfoPartner?.phone_number?.e164 ? ", " + visaInfoPartner?.phone_number?.e164 : ""}{visaInfoPartner?.website_urls ? ", " + visaInfoPartner?.website_urls : ""}</div>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
    
                        <Accordion className='border-hidden label-style' style={{marginBottom: 12}} id={"accordion-iias-active"}>
                            <Accordion.Item eventKey="0" className='label-style'>
                                <Accordion.Header className='document-item label-style'>{t('partnerData.insurance.title')}</Accordion.Header>
                                <Accordion.Body className='border-hidden label-style'>
                                    <div className='body' style={{marginTop: 8, fontStyle: "italic", paddingLeft: 12}}>{t('partnerData.insurance.description.part1')}<br/>{t('partnerData.insurance.description.part2')}<br/>{t('partnerData.insurance.description.part3')}</div>
                                    <div className='h6-style' style={{marginTop: 10, paddingLeft: 12}}>{t('partnerData.insurance.contact')} </div>
                                    <div className='body' style={{marginTop: 8, paddingLeft: 12}}>{insuranceInfoPartner?.email}{insuranceInfoPartner?.phone_number?.e164 ? ", " + insuranceInfoPartner?.phone_number?.e164 : ""}{insuranceInfoPartner?.website_urls ? ", " + insuranceInfoPartner?.website_urls : ""}</div>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
    
                        <Accordion className='border-hidden label-style' style={{marginBottom: 12}} id={"accordion-iias-active"}>
                            <Accordion.Item eventKey="0" className='label-style'>
                                <Accordion.Header className='document-item label-style'>{t('partnerData.additionalInfo.title')}</Accordion.Header>
                                <Accordion.Body className='border-hidden label-style'>
                                    <div className='body' style={{marginTop: 15, fontStyle: "italic", paddingLeft: 12}}>{t('partnerData.additionalInfo.description.part1')}<br/>{t('partnerData.additionalInfo.description.part2')}</div>
                                    {additionalInfosPartner?.map((elem, index) => (
                                        <>
                                        <div className='h6-style' style={{marginTop: 22, paddingLeft: 12}}>{elem?.type} </div>
                                        <Table responsive>
                                            <thead className='thead-font'>
                                                <tr>
                                                <th style={{paddingTop: 15, paddingBottom: 2, paddingLeft: 12}} className='border-hidden label-style'>{t('partnerData.additionalInfo.contact')}</th>
                                                </tr>
                                            </thead>
                                            <tbody className='tbody-font'>
                                                <tr>
                                                <td style={{paddingBottom: 20, paddingLeft: 12}} className='border-hidden body'>{elem?.info?.email}{elem?.info?.phone_number?.e164 ? ", " 
                                                + elem?.info?.phone_number?.e164 : ""}{elem?.info?.website_urls?.length > 0 ? ", " 
                                                + elem?.info?.website_urls : ""}</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                        </>
                                    ))}
                                    
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                        <Row><Col style={{background: "#FFFFFF", borderRadius: 10, marginLeft: 8, marginRight: 8}}><div style={{marginLeft: 30, marginTop: 20, marginBottom: 20}} className='body'>{t('partnerData.message.part1')}<br/>
    {t('partnerData.message.part2')}<br/>
    {t('partnerData.message.part3')}</div></Col></Row>
                    </Col>
                </Row>)
                :
                (
                            <Row style={{marginLeft: 25, marginRight: 25}}>
                                <Col style={{marginTop: 30, marginBottom: 12}} md={12} lg={12}>
                                
                                    
                                    <Accordion className='border-hidden label-style' style={{marginBottom: 12}} id={"accordion-iias-active"}>
                                        <Accordion.Item eventKey="0" className='label-style'>
                                            <Accordion.Header className='document-item label-style'>CALENDAR</Accordion.Header>
                                            <Accordion.Body className='border-hidden label-style' >
                                                <div style={{paddingLeft: 12, paddingTop: 15, paddingBottom: 20}}>
                                                <div className='h6-style'>Student Nominations must reach the Receiving Institution by: </div>
                                                <Row style={{marginTop: 12}}>
                                                    <Col lg={1}>Autumn Term: </Col>
                                                    <Col lg={11} className='body'>{calendarNomAutumnPartner}</Col>
                                                </Row>
                                                
                                                <Row style={{marginTop: 12}}>
                                                    <Col lg={1}>Spring Term: </Col>
                                                    <Col lg={11} className='body'>{calendarNomSpringPartner}</Col>
                                                </Row>
                                                <div className='h6-style' style={{marginTop: 22}}>Applications for Nominated Students must reach the Receiving Institution by: </div>
                                                <Row style={{marginTop: 12}}>
                                                    <Col lg={1}>Autumn Term: </Col>
                                                    <Col lg={11} className='body'>{calendarAppAutumnPartner}</Col>
                                                </Row>
                                                
                                                <Row style={{marginTop: 12}}>
                                                    <Col lg={1}>Spring Term: </Col>
                                                    <Col lg={11} className='body'>{calendarAppSpringPartner}</Col>
                                                </Row>
                                                <div className='h6-style' style={{marginTop: 22}}>Application procedure for Nominated Students: </div>
                                                <Row style={{marginTop: 12}}>
                                                    <Col lg={2}>Contact Email: </Col>
                                                    <Col lg={10} className='body'>{applicationInfoEmailPartner}</Col>
                                                </Row>
                                                
                                                <Row style={{marginTop: 12}}>
                                                    <Col lg={2}>Contact Phone: </Col>
                                                    <Col lg={10} className='body'>{applicationInfoPhonePartner}</Col>
                                                </Row>
                                                <Row style={{marginTop: 12}}>
                                                    <Col lg={2}>Website for information: </Col>
                                                    <Col lg={10} className='body'>{applicationInfoWebsitePartner?.length > 0 && applicationInfoWebsitePartner}</Col>
                                                </Row>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                
                                    
                                    <Accordion className='border-hidden label-style' style={{marginBottom: 12}} id={"accordion-iias-active"}>
                                        <Accordion.Item eventKey="0" className='label-style'>
                                            <Accordion.Header className='document-item label-style'>ADDITIONAL REQUIREMENTS</Accordion.Header>
                                            <Accordion.Body className='border-hidden label-style'>
                                            {additionalRequirementsPartner?.map((elem, index) => (
                                                <div class="p-3  justify-content-around align-items-center">
                                            
                                                <div className="row">
                                                    <div className="col table-header">
                                                        {"REQUIREMENT:"}
                                                    </div>
                                                    <div className="col body">
                                                        {elem?.name}
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col table-header">
                                                        {"DETAILS:"}
                                                    </div>
                                                    <div className="col body">
                                                        {elem?.details}
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col table-header">
                                                        {"ECTS NUMBER:"}
                                                    </div>
                                                    <div className="col body">
                                                        {elem?.ects}
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col table-header">
                                                        {"SUBJECT FIELD (ISCED):"}
                                                    </div>
                                                    <div className="col body">
                                                        {elem?.isced_f_code + elem?.isced_f_code_name}
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col table-header">
                                                        {"STUDY LEVEL (EQF):"}
                                                    </div>
                                                    <div className="col body">
                                                        {elem?.eqf_level}
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col table-header">
                                                        {"WEBSITE:"}
                                                    </div>
                                                    <div className="col body">
                                                    <a href={elem?.information_websites} target="_blank" style={{textDecoration: "none"}}>{elem?.information_websites}</a>
                                                    </div>
                                                </div>
                                                </div>
                                            ))}
                                            <div className='body' style={{marginTop: 15, fontStyle: "italic", paddingLeft: 12}}>The institution will send its decision within 4 weeks, and no later than 5 weeks.</div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                
                                    <Accordion className='border-hidden label-style' style={{marginBottom: 12}} id={"accordion-iias-active"}>
                                        <Accordion.Item eventKey="0" className='label-style'>
                                            <Accordion.Header className='document-item label-style'>INCLUSION AND ACCESSIBILITY</Accordion.Header>
                                            <Accordion.Body className='border-hidden label-style'>
                                                <div className='body' style={{marginTop: 15, fontStyle: "italic", paddingLeft: 12}}>The institution will provide support to incoming mobile participants with special needs, according to the requirements of the Erasmus Charter for Higher Education.<br/> Information and assistance can be provided by the following contact points and information sources:</div>
                                                <div className='h6-style' style={{marginTop: 22, paddingLeft: 12}}>Infrastructure </div>
                                                {accessibilitiesPartner?.map((elem, index) => (
                                                    elem?.type === "infrastructure" && <div class="p-3  justify-content-around align-items-center">
                                                    <div className="row">
                                                        <div className="col table-header">
                                                            {"NAME:"}
                                                        </div>
                                                        <div className="col body">
                                                            {elem?.name}
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col table-header">
                                                            {"DESCRIPTION:"}
                                                        </div>
                                                        <div className="col body">
                                                            {elem?.description}
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col table-header">
                                                            {"CONTACT:"}
                                                        </div>
                                                        <div className="col body">
                                                        {elem?.info?.email}{elem?.info?.phone_number?.e164 ? ", " 
                                                            + elem?.info?.phone_number?.e164 : ""}{elem?.info?.website_urls ? ", " 
                                                            + elem?.info?.website_urls : ""}
                                                        </div>
                                                    </div>
                                                    </div>
                                                ))}
                                                
                                                
                                                <div className='h6-style' style={{marginTop: 22, paddingLeft: 12}}>Services</div>
                                                {accessibilitiesPartner?.map((elem, index) => (
                                                    elem?.type === "service" && <div class="p-3  justify-content-around align-items-center">
                                                    <div className="row">
                                                        <div className="col table-header">
                                                            {"NAME:"}
                                                        </div>
                                                        <div className="col body">
                                                            {elem?.name}
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col table-header">
                                                            {"DESCRIPTION:"}
                                                        </div>
                                                        <div className="col body">
                                                            {elem?.description}
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col table-header">
                                                            {"CONTACT:"}
                                                        </div>
                                                        <div className="col body">
                                                        {elem?.info?.email}{elem?.info?.phone_number?.e164 ? ", " 
                                                            + elem?.info?.phone_number?.e164 : ""}{elem?.info?.website_urls ? ", " 
                                                            + elem?.info?.website_urls : ""}
                                                        </div>
                                                    </div>
                                                    </div>
                                                ))}
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                
                                    <Accordion className='border-hidden label-style' style={{marginBottom: 12}} id={"accordion-iias-active"}>
                                        <Accordion.Item eventKey="0" className='label-style'>
                                            <Accordion.Header className='document-item label-style'>HOUSING</Accordion.Header>
                                            <Accordion.Body className='border-hidden label-style'>
                                                <div className='body' style={{marginTop: 8, fontStyle: "italic", paddingLeft: 12}}>The institution will guide incoming mobile participants in finding accommodation, according to the requirements of the Erasmus Charter for Higher Education.<br/> Information and assistance can be provided by the following contact points and information sources:</div>
                                                <div className='h6-style' style={{marginTop: 10, paddingLeft: 12}}>Contact </div>
                                                <div className='body' style={{marginTop: 8, paddingLeft: 12}}>{housingInfoPartner?.email}{housingInfoPartner?.phone_number?.e164 ? ", " + housingInfoPartner?.phone_number?.e164 : ""}{housingInfoPartner?.website_urls ? ", " + housingInfoPartner?.website_urls : ""}</div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                
                                    <Accordion className='border-hidden label-style' style={{marginBottom: 12}} id={"accordion-iias-active"}>
                                        <Accordion.Item eventKey="0" className='label-style'>
                                            <Accordion.Header className='document-item label-style'>VISA</Accordion.Header>
                                            <Accordion.Body className='border-hidden label-style'>
                                                <div className='body' style={{marginTop: 8, fontStyle: "italic", paddingLeft: 12}}>The institution will provide assistance, when required, in securing visas for incoming and outbound mobile participants, according to the requirements of the Erasmus Charter for Higher Education.<br/> Information and assistance can be provided by the following contact points and information sources:</div>
                                                <div className='h6-style' style={{marginTop: 10, paddingLeft: 12}}>Contact </div>
                                                <div className='body' style={{marginTop: 8, paddingLeft: 12}}>{visaInfoPartner?.email}{visaInfoPartner?.phone_number?.e164 ? ", " + visaInfoPartner?.phone_number?.e164 : ""}{visaInfoPartner?.website_urls ? ", " + visaInfoPartner?.website_urls : ""}</div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                
                                    <Accordion className='border-hidden label-style' style={{marginBottom: 12}} id={"accordion-iias-active"}>
                                        <Accordion.Item eventKey="0" className='label-style'>
                                            <Accordion.Header className='document-item label-style'>INSURANCE</Accordion.Header>
                                            <Accordion.Body className='border-hidden label-style'>
                                                <div className='body' style={{marginTop: 8, fontStyle: "italic", paddingLeft: 12}}>The institution will provide assistance in obtaining insurance for incoming and outbound mobile participants, according to the requirements of the Erasmus Charter for Higher Education.<br/> The receiving institution will inform mobile participants of cases in which insurance cover is not automatically provided.<br/> Information and assistance can be provided by the following contact points and information sources:</div>
                                                <div className='h6-style' style={{marginTop: 10, paddingLeft: 12}}>Contact </div>
                                                <div className='body' style={{marginTop: 8, paddingLeft: 12}}>{insuranceInfoPartner?.email}{insuranceInfoPartner?.phone_number?.e164 ? ", " + insuranceInfoPartner?.phone_number?.e164 : ""}{insuranceInfoPartner?.website_urls ? ", " + insuranceInfoPartner?.website_urls : ""}</div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                
                                    <Accordion className='border-hidden label-style' style={{marginBottom: 12}} id={"accordion-iias-active"}>
                                        <Accordion.Item eventKey="0" className='label-style'>
                                            <Accordion.Header className='document-item label-style'>ADDITIONAL INFORMATION</Accordion.Header>
                                            <Accordion.Body className='border-hidden label-style'>
                                                <div className='body' style={{marginTop: 15, fontStyle: "italic", paddingLeft: 12}}>The institution will provide support to incoming mobile participants with special needs, according to the requirements of the Erasmus Charter for Higher Education.<br/> Information and assistance can be provided by the following contact points and information sources:</div>
                                                {additionalInfosPartner?.map((elem, index) => (
                                                    <>
                                                    <div className='h6-style' style={{marginTop: 22, paddingLeft: 12}}>{elem?.type} </div>
                                                    <Table responsive>
                                                        <thead className='thead-font'>
                                                            <tr>
                                                            <th style={{paddingTop: 15, paddingBottom: 2, paddingLeft: 12}} className='border-hidden label-style'>CONTACT</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className='tbody-font'>
                                                            <tr>
                                                            <td style={{paddingBottom: 20, paddingLeft: 12}} className='border-hidden body'>{elem?.info?.email}{elem?.info?.phone_number?.e164 ? ", " 
                                                            + elem?.info?.phone_number?.e164 : ""}{elem?.info?.website_urls?.length > 0 ? ", " 
                                                            + elem?.info?.website_urls : ""}</td>
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                    </>
                                                ))}
                                                
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                    <Row><Col style={{background: "#FFFFFF", borderRadius: 10, marginLeft: 8, marginRight: 8}}><div style={{marginLeft: 30, marginTop: 20, marginBottom: 20}} className='body'>A Transcript of Records will be issued by the institution no later than 6 weeks after the assessment period has finished.<br/>
                [It should normally not exceed five weeks according to the Erasmus Charterfor Higher Education guidelines]<br/>
                *After creating the profile of the higher education institution and adding the relevant general information, the higher education institution can proceed to generate Inter-Institutional Agreements with their selected partners.</div></Col></Row>
                                </Col>
                            </Row>)
    }
    </>
    }
    />
    </div>
    </>
    )
}

export default PartnerFactSheetModal;